import {Hal} from './hal.model';

export class FormHal extends Hal {
  identifier: string;
  title: string;

  constructor(data: any) {
    super(data);
    this.identifier = data.identifier;
    this.title = data.title;
  }
}

class Embedded {
  forms: FormHal[];

  constructor(data: any) {
    this.forms = data.forms.map((data: any) => new FormHal(data));
  }
}

export class FormCollectionHal extends Hal {
  _embedded?: Embedded;

  constructor(data: any) {
    super(data);
    if (data._embedded) {
      this._embedded = new Embedded(data._embedded);
    }
  }
}
